import { CandidateProfileModel, ICandidateProfile } from "@core/models";

export const mockAccount = new CandidateProfileModel({
  [ICandidateProfile.firstname]: "smith",
  [ICandidateProfile.lastname]: "john",
  [ICandidateProfile.birthdate]: "2000-03-11",
  [ICandidateProfile.street]: "10 rue du paradis",
  [ICandidateProfile.city]: "paris",
  [ICandidateProfile.postalCode]: "75000",
  [ICandidateProfile.hasVehicle]: true,
  [ICandidateProfile.avatar]: "",
  [ICandidateProfile.about]: "",
  [ICandidateProfile.phone]: "0606060608",
  [ICandidateProfile.email]: "demo@gmail.com",
});
